import EmptyState from "@/components/EmptyState";
import {
  applyBackendSource,
  getActiveBackendSource,
  getBackendSourceLabel,
  getLocalBackendOrigin,
  isBackendSourceToggleAvailable
} from "@/lib/backendSource";

function canSwitchConfigurationToLocalBackend() {
  return isBackendSourceToggleAvailable() && getActiveBackendSource() === "shared-dev";
}

export default function ConfigurationLoadError({ onRetry }: { onRetry: () => void }) {
  if (canSwitchConfigurationToLocalBackend()) {
    const sharedDevLabel = getBackendSourceLabel("shared-dev");
    const localLabel = getBackendSourceLabel("localhost");

    return (
      <EmptyState
        iconName="dns"
        title="This Page Needs Your Local API"
        caption={`Member 360 Configuration isn't on ${sharedDevLabel} yet. Switch to ${localLabel} to open it.`}
        action={{
          children: "Use local backend",
          variant: "filled",
          testId: "backend-source-localhost",
          onClick: () => applyBackendSource("localhost")
        }}
      />
    );
  }

  const localHint =
    isBackendSourceToggleAvailable() && getActiveBackendSource() === "localhost"
      ? ` Confirm your local API is running at ${getLocalBackendOrigin()}, then try again.`
      : " If this keeps happening, contact PGA Technology.";

  return (
    <EmptyState
      iconName="error"
      title="Couldn't Load This Page"
      caption={`We couldn't load Member 360 Configuration.${localHint}`}
      action={{ children: "Try again", onClick: onRetry, testId: "configuration-load-retry" }}
    />
  );
}
